import React, { Component } from "react";
import ScrollableAnchor from 'react-scrollable-anchor'

import "./FooterBanner.scss"
import dataJSON from "../../api/FooterBanner.json"

class FooterBanner extends Component {
  constructor() {
    super();
    this.state = {}
  }
  linkDataLayer() {
    window.dataLayer.push({
      'event': 'GA_Event',
      'Category': 'nespresso',
      'Action': 'Purchase_products',
      'Label': ""
    });
    window.open(dataJSON.link, "_parent");
  }
  render() {
    return (
      <ScrollableAnchor id={`gift`}>
      <section className="section section-special">
        <div className="flowers">
          <div className="flower"></div>
        </div>
        <div className="padding">
          <div className="container" onClick={this.linkDataLayer}>
            <div className="glass"></div>
            <div className="teaser">
              <div className="text" dangerouslySetInnerHTML={{__html: dataJSON.text}}></div>
              <div className="button">
                <div className="button-text">
                    {dataJSON.button.text}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </ScrollableAnchor>
    );
  }
}

export default FooterBanner;



// WEBPACK FOOTER //
// ./src/Components/FooterBanner/FooterBanner.js